import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { instance } from "Actions/AxiosInstance";
import downloadIcon from "Assets/newicons/action/download/outline/download-outline-16px.svg";
import uploadIcon from "Assets/newicons/action/upload/outline/upload-outline-16px.svg";
import PageHeader from "Component/Headers/pageHeader";
import IconWithBackground from "Component/Icons/iconWithBackground";
import SearchRound from "Component/Material-ui/SearchRound";
import ProfilePictureSmall from "Component/Thumbnail/ProfilePictureSmall";
import { ErrorMessages } from "Constants";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import * as FileSaver from "file-saver";
import get from "lodash/get";
import moment from "moment";
import { withSnackbar } from "notistack";
import React from "react";
import { connect } from "react-redux";
import readXlsxFile from "read-excel-file";
import { getFormattedImageLink, getMonthName } from "Utils";
import { getmonthyearonly } from "Utils/dates";
import * as XLSX from "xlsx";
import { GetFeature } from "Actions/commonAction";

const TEMP = [
  {
    employeename: "Name",
    primarymobile: "Mobile",
    remark: "Remarks",
    paymentamount: "Amount",
    salarycomponentidname: "Salary component",
  },
  {
    employeename: "Name 1",
    primarymobile: "Mobile",
    remark: "Remarks",
    paymentamount: "Amount",
    salarycomponentidname: "Salary component",
  },
  {
    employeename: "Name 2",
    primarymobile: "Mobile",
    remark: "Remarks",
    paymentamount: "Amount",
    salarycomponentidname: "Salary component",
  },
];

export const ExportArrearsXLSX = (props = {}) => {
  const { rows = TEMP, empobjindex = 10, date = "", name = "" } = props;
  const filename = `Lop_Arrears_${getMonthName(name.split("-")[0])}_${
    name.split("-")[1]
  }.xlsx`;
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  let header = [
    "empfullname",
    "department",
    "designation",
    "businessunit",
    "lop_1",
  ];
  if (empobjindex == 8 || empobjindex == 10) {
    header = [...header, "loparrears_1", "lop_2"];
  }
  if (empobjindex == 10) {
    header = [...header, "loparrears_2", "lop_3"];
  }
  header = [...header, "employeeobj"];

  const ws = XLSX.utils.json_to_sheet([...rows], {
    header,
    skipHeader: true,
  });
  /* hide employeeid column */
  ws["!cols"] = [];
  ws["!cols"][empobjindex - 1] = { hidden: true };

  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, filename);
};

const styles = () => ({
  drawerPaper: {
    width: 356,
  },
});

const EXCELCONST = [];

class GratuityPayments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 1,
      fromdate: "",
      selectedEmployee: null,
      List: [],
      filterList: [],
      time1: 0,
      isloading: false,
    };
    this.getdata = this.getdata.bind(this);
    this.onSave = this.onSave.bind(this);
  }

  componentDidMount() {
    this.getdata();
  }

  getdata() {
    const {
      salarycycle,
      payrollcycle,
      isSpeicalCase,
      specialEmps,
      normalEmps,
    } = this.props;

    const intMonthid = get(salarycycle, "payrollmonthid", 12);
    const intYear = get(salarycycle, "payrollyear", 2019);
    const payrollcycleid = get(salarycycle, "payrollcycleid", 4);
    const getDataObj = (arr, employeeid) => {
      const result = arr.find((x) => x.employeeid == employeeid);
      return result
        ? result
        : {
            gratuitytypeid: 2,
            gratuityamount: 0,
            employeeid,
          };
    };
    const postdata = {
      monthid: intMonthid,
      year: intYear,
      payrollcycledurationid: get(payrollcycle, "payrollcycledurationid", 12),
      salarycycleid: get(salarycycle, "salarycycleid", 12),
      salarycyclesplitid: get(salarycycle, "displayvalue", 12),
      payrollcycleid,
      employeeids: isSpeicalCase
        ? specialEmps.map((x) => x.employeeid)
        : normalEmps.map((x) => x.employeeid),
    };
    instance
      .post("payroll/getemployeesgaduity", postdata)
      .then((resp1) => {
        const finalres = isSpeicalCase
          ? specialEmps.map((x) => ({
              ...x,
              ...getDataObj(get(resp1, "data.result", []), x.employeeid),
            }))
          : normalEmps.map((x) => ({
              ...x,
              ...getDataObj(get(resp1, "data.result", []), x.employeeid),
            }));
        this.setState({
          employeelist: isSpeicalCase ? specialEmps : normalEmps,
          List: finalres,
          filterList: finalres,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  async uploadData(e) {
    console.log("e: ", e);
    const { List, empobjindex } = this.state;
    const _file = e.target.files[0];
    console.log("_file: ", _file);
    if (!_file) {
      return;
    }
    const imgname = _file.name;
    let idxDot = "";
    let extFile = "";
    idxDot = imgname.lastIndexOf(".") + 1;
    extFile = imgname.substr(idxDot, imgname.length).toLowerCase();
    if (extFile != "xlsx") {
      this.props.enqueueSnackbar("Please select valid file format", {
        variant: "error",
      });
      return;
    }
    try {
      let rows = await readXlsxFile(_file);
      console.log("rows1: ", rows);
      rows = rows
        ? rows.filter(
            (x, i) =>
              i !== 0 &&
              x[0] &&
              x[1] &&
              x[2] &&
              (empobjindex == 6 ? x[5] : true) &&
              (empobjindex == 8 ? x[7] : true) &&
              (empobjindex == 10 ? x[9] : true),
          )
        : [];
      console.log("rows2: ", rows, rows[0]);
      // return;
      if (rows && rows[0]) {
        // rows = rows.slice(0, 1);
        console.log("rows3: ", rows);
        let valid = true;
        const result = [...List].map((x) => {
          if (valid) {
            const getempid = (str) => {
              const res = JSON.parse(str);
              return res.employeeid;
            };
            const thisinput = rows.find(
              (row) => x.employeeid == getempid(row[empobjindex - 1]),
            ) || ["", "", "", "", 0, 0, 0, 0, 0, ""];
            console.log("thisinput: ", thisinput);
            if (isNaN(thisinput[4])) {
              this.props.enqueueSnackbar("Invalid values occured", {
                variant: "error",
              });
              valid = false;
            }
            x = {
              ...x,
              updatedfromexcel: true,
              lop_1: { ...x.lop_1, effectivelop: thisinput[4] },
            };
            if (valid && empobjindex == 10) {
              if (
                isNaN(thisinput[5]) ||
                isNaN(thisinput[6]) ||
                isNaN(thisinput[7]) ||
                isNaN(thisinput[8])
              ) {
                this.props.enqueueSnackbar("Invalid values occured", {
                  variant: "error",
                });
                valid = false;
              }
              x.lop_3 = { ...x.lop_3, effectivelop: thisinput[8] };

              x.lop_2 = { ...x.lop_2, effectivelop: thisinput[6] };
              x.loparrears_2 = {
                ...x.loparrears_2,
                effectiveloparrears: thisinput[7],
              };
              x.loparrears_1 = {
                ...x.loparrears_1,
                effectiveloparrears: thisinput[5],
              };
            } else if (valid && empobjindex == 8) {
              if (isNaN(thisinput[5]) || isNaN(thisinput[6])) {
                this.props.enqueueSnackbar("Invalid values occured", {
                  variant: "error",
                });
                valid = false;
              }
              x.lop_2 = { ...x.lop_2, effectivelop: thisinput[6] };

              x.loparrears_1 = {
                ...x.loparrears_1,
                effectiveloparrears: thisinput[5],
              };
            }
            return x;
          }
          return x;
        });
        if (valid) {
          this.setState({ List: result });
        } else {
          this.props.enqueueSnackbar("Invalid values occured", {
            variant: "error",
          });
          this.setState({ List: [] });
        }
      } else {
        this.props.enqueueSnackbar(ErrorMessages.E0070, { variant: "error" });
      }
    } catch (error) {
      console.log("error: ", error);
      this.props.enqueueSnackbar(ErrorMessages.E0070, { variant: "error" });
    }
  }

  onSave() {
    const { salarycycle = null } = this.props;
    const { List, empobjindex } = this.state;
    const { issaveinprogress } = this.props.SaveInProgressReducer;
    console.log("issaveinprogress: ", issaveinprogress);
    if (!issaveinprogress) {
      this.props.setSaveProgress(true);
      const monthid = get(salarycycle, "payrollmonthid", 12);
      const year = get(salarycycle, "payrollyear", 2019);
      const uploadlops = [];
      const uploadlopspostdata = [...List].filter((x) => x.updatedfromexcel);
      uploadlopspostdata.forEach((x) => {
        if (empobjindex == 10) {
          uploadlops.push({
            salarycycleid: get(x, "lop_3.salarycycleid", 0),
            salarycyclesplitid: get(x, "lop_3.salarycyclesplitid", 0),
            payrollcycledurationid: get(x, "lop_3.payrollcycledurationid", 0),
            arrearsmonthid: monthid,
            arrearsyear: year,
            lop: get(x, "lop_3.lop", 0),
            effectivelop: get(x, "lop_3.effectivelop", 0),
            loparrears: get(x, "loparrears_3.loparrears", 0),
            effectiveloparrears: get(x, "loparrears_3.effectiveloparrears", 0),
            iscurrent: get(x, "lop_3.payrollmonthid", "") == monthid,
            employeeid: get(x, "employeeid", ""),
            parentuploadlopid: get(x, "lop_3.parentuploadlopid", ""),
          });
        }
        if (empobjindex == 8 || empobjindex == 10) {
          uploadlops.push({
            salarycycleid: get(x, "lop_2.salarycycleid", 0),
            salarycyclesplitid: get(x, "lop_2.salarycyclesplitid", 0),
            payrollcycledurationid: get(x, "lop_2.payrollcycledurationid", 0),
            arrearsmonthid: monthid,
            arrearsyear: year,
            lop: get(x, "lop_2.lop", 0),
            effectivelop: get(x, "lop_2.effectivelop", 0),
            loparrears: get(x, "loparrears_2.loparrears", 0),
            effectiveloparrears: get(x, "loparrears_2.effectiveloparrears", 0),
            iscurrent: get(x, "lop_2.payrollmonthid", "") == monthid,
            employeeid: get(x, "employeeid", ""),
            parentuploadlopid: get(x, "lop_2.parentuploadlopid", ""),
          });
        }
        uploadlops.push({
          salarycycleid: get(x, "lop_1.salarycycleid", 0),
          salarycyclesplitid: get(x, "lop_1.salarycyclesplitid", 0),
          payrollcycledurationid: get(x, "lop_1.payrollcycledurationid", 0),
          arrearsmonthid: monthid,
          arrearsyear: year,
          lop: get(x, "lop_1.lop", 0),
          effectivelop: get(x, "lop_1.effectivelop", 0),
          loparrears: get(x, "loparrears_1.loparrears", 0),
          effectiveloparrears: get(x, "loparrears_1.effectiveloparrears", 0),
          iscurrent: get(x, "lop_1.payrollmonthid", "") == monthid,
          employeeid: get(x, "employeeid", ""),
          parentuploadlopid: get(x, "lop_1.parentuploadlopid", ""),
        });
      });

      console.log("uploadlops: ", uploadlops);
      // return;
      const totalseconds = uploadlops.length * 3;
      const secondsforintervals = totalseconds * 1000;
      this.interval = setInterval(
        () =>
          this.setState({
            time1: this.state.time1 >= 99 ? 99 : this.state.time1 + 1,
          }),
        secondsforintervals / 100,
      );

      this.setState(
        {
          // time1: 0,
          isloading: true,
        },
        () => {
          instance
            .post("payroll/bulkuploadlop", { uploadlops })
            .then(() => {
              this.props.removeSaveProgress();
              this.props.enqueueSnackbar("Uploaded successfully", {
                variant: "success",
              });
              this.setState({
                time1: 100,
                isloading: false,
              });
              this.getdata();
            })
            .catch((error) => {
              this.props.removeSaveProgress();
              this.setState({
                time1: 100,
                isloading: false,
              });
              this.props.enqueueSnackbar(
                error.response
                  ? error.response.data.error.message
                  : error.message,
                { variant: "error" },
              );
            });
        },
      );
    }
  }

  handleSearch = (e) => {
    const { List, filterList } = this.state;
    const FF = List.filter(
      (item) =>
        item.empfullname.toLowerCase().search(e.target.value.toLowerCase()) !==
        -1,
    );
    this.setState({
      searchValue: e.target.value,
      List: e.target.value ? FF : filterList,
    });
  };

  ExportData = () => {
    const { salarycycle } = this.props;
    const { employeelist } = this.state;
    const date = salarycycle
      ? salarycycle.cycleto
      : moment(new Date()).format("YYYY-MM-DD");
    const feature = GetFeature("runpayroll");
    const name = salarycycle && salarycycle.displayname;
    const filename = `Manual_Tax_${getMonthName(name.split("-")[0])}_${
      name.split("-")[1]
    }.xlsx`;
    if (feature) {
      instance
        .get(
          `/payroll/getxlsforgraduity/null/null/null/null/${employeelist
            .map((x) => x.employeeid)
            .join(",")}/${feature.profilemenuactionid}`,
          { responseType: "blob" },
        )
        .then((result) => {
          const url = window.URL.createObjectURL(new Blob([result.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
        });
    }
  };

  render() {
    const { classes } = this.props;
    const {
      selectedEmployee,
      searchValue,
      List = [],
      empobjindex = 10,
    } = this.state;
    // const List = searchValue ? filterList : salarysheet;
    const { setsalaryadjustpage } = this.props;
    const firstemployee = get(List, "[0]", EMPOBJ);

    return (
      <div className="innerwrapper-full-width">
        <div className="margin-top-4">
          <PageHeader header="Step 3.5: Gratuity payment" />
        </div>
        <p className="normal-dark-secondary margin-bottom-16">
          View and add gratuity payment all in one place
        </p>
        <Grid container>
          <Grid item xs={12} md={8} sm={12}>
            <div className="floatleft margin-right-8 cursour-pointer">
              <SearchRound
                placeholder="Search employee"
                value={searchValue}
                onChange={this.handleSearch}
              />
            </div>

            <div
              className="margin-right-8 floatleft cursour-pointer"
              onClick={this.ExportData}
            >
              <IconWithBackground imgsrc={downloadIcon} />
            </div>
            <div
              className="margin-right-8 floatleft cursour-pointer"
              onClick={() => {
                document.getElementById("fileupload").click();
              }}
            >
              <input
                id="fileupload"
                type="file"
                name="Upload Emploxyee Data"
                onChange={(e) => this.uploadData(e)}
                hidden
              />
              <IconWithBackground imgsrc={uploadIcon} />
            </div>
          </Grid>
        </Grid>
        <Grid container spacing={3} className="margin-top-8 padding-bottom-90">
          <Grid item xs={12} md={8} sm={12} style={{ overflowX: "hidden" }}>
            <Table
              className="payroll-data-table"
              size="small"
              aria-label="a dense table"
            >
              <TableHead className={classes.tablehead}>
                <TableRow style={{ height: 44 }}>
                  <TableCell align="left">Name</TableCell>
                  <TableCell align="right">Employee ID</TableCell>
                  <TableCell align="right">Gratuity amount</TableCell>
                  <TableCell align="right">Gratuity type</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {List.map((row) => (
                  <TableRow
                    key={row.empsalarysheetid}
                    onClick={() => this.setState({ selectedEmployee: row })}
                    className={`t-12 cursour-pointer ${
                      row.employeeid ==
                        get(selectedEmployee, "employeeid", "") &&
                      "bg-color-f7f8f8"
                    }`}
                  >
                    <TableCell align="left">
                      <div
                        className="floatleft margin-right-8"
                        style={{ height: 32 }}
                      >
                        <ProfilePictureSmall
                          src={getFormattedImageLink(row.imagepath)}
                        />
                      </div>
                      <div className="floatleft margin-top-8 width70">
                        <p className="small-dark-secondary ellipsis">
                          {row.empfullname}
                        </p>
                      </div>
                    </TableCell>

                    <TableCell align="center">
                      {row.employeecode || "-"}
                    </TableCell>
                    <TableCell align="right">{row.gratuityamount}</TableCell>
                    <TableCell align="right">
                      {row.gratuitytypeid == 1
                        ? `Gratuity (CTC)`
                        : `Gratuity (Non CTC)`}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Grid>
        </Grid>

        <div className="width100">
          <div>
            <div className="floatleft" style={{ marginLeft: 172 }}>
              <div
                className="width100"
                style={{
                  position: "fixed",
                  left: 0,
                  background: "white",
                  bottom: 0,
                  padding: 10,
                  borderTop: "1px solid #d4d4d4",
                  zIndex: 0,
                }}
              >
                <div>
                  <div className="floatleft" style={{ marginLeft: 172 }}>
                    <Button
                      className="btn btn-secondary-md-blue margin-right-16"
                      variant="contained"
                      onClick={() => setsalaryadjustpage("home")}
                    >
                      Go back
                    </Button>
                  </div>
                  <div className="floatright" style={{ marginRight: 72 }}>
                    <div>
                      <Button
                        className="btn btn-primary-md-blue"
                        variant="contained"
                        disabled={
                          this.props.SaveInProgressReducer.issaveinprogress
                        }
                        onClick={this.onSave}
                        // onClick={this.analysedData()}
                      >
                        Save
                      </Button>
                    </div>
                  </div>
                  <div className="clearfloat"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Dialog
          fullWidth={true}
          maxWidth="sm"
          open={this.state.isloading}
          // onClose={() => this.setState({ openDialog: false, empform1: null })}
          aria-labelledby="max-width-dialog-title"
          classes={{
            scrollPaper: "no-shadow bg-transparent",
            paper: "no-shadow bg-transparent",
          }}
        >
          <DialogContent>
            <div
              className="progess-wrapper"
              style={{
                position: "relative",
                width: 120,
                height: 120,
                margin: "0 auto",
                color: "#fff",
              }}
            >
              <CircularProgress
                className="goal-progress"
                variant="static"
                value={this.state.time1}
                color="inherit"
              />
              <div
                className="progress-line"
                style={{ borderColor: "#fff" }}
              ></div>
              <div
                className="vertical-center text-center"
                style={{ height: 30 }}
              >
                <span
                  style={{
                    display: "block",
                    fontSize: 24,
                    color: "#fff",
                    fontWeight: "bold",
                  }}
                >
                  {this.state.time1}%
                </span>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

export default connect()(
  withStyles(styles, { withTheme: true })(withSnackbar(GratuityPayments)),
);

const EMPOBJ = {
  employeeid: "",
  lop_1: {
    lop: 0,
    salarycycleid: 48,
    salarycyclesplitid: 91,
    payrollcycledurationid: 1,
    payrollmonthid: 10,
    payrollyear: 2019,
    payrollmonthyear: "LOP",
  },
  loparrears_1: {
    loparrears: 0,
    salarycycleid: 48,
    salarycyclesplitid: 91,
    payrollcycledurationid: 1,
    payrollmonthid: 10,
    payrollyear: 2019,
    payrollmonthyear: "LOP Arrears",
  },
  lop_2: {
    lop: 0,
    salarycycleid: 48,
    salarycyclesplitid: 92,
    payrollcycledurationid: 1,
    payrollmonthid: 11,
    payrollyear: 2019,
    payrollmonthyear: "LOP",
  },
  loparrears_2: {
    loparrears: 0,
    salarycycleid: 48,
    salarycyclesplitid: 92,
    payrollcycledurationid: 1,
    payrollmonthid: 11,
    payrollyear: 2019,
    payrollmonthyear: "LOP Arrears",
  },
  lop_3: {
    lop: 0,
    salarycycleid: 48,
    salarycyclesplitid: 92,
    payrollcycledurationid: 1,
    payrollmonthid: 12,
    payrollyear: 2019,
    payrollmonthyear: "LOP",
  },
  loparrears_3: {
    loparrears: 0,
    salarycycleid: 48,
    salarycyclesplitid: 93,
    payrollcycledurationid: 1,
    payrollmonthid: 12,
    payrollyear: 2019,
    payrollmonthyear: "LOP Arrears",
  },
};
